/** @format */

import React from "react";
import { Order, User } from "../../../services";
import { toast } from "react-toastify";

const OrdersParsingData = async (orderId, lang="ru", setStateFunctions) => {
  const {
    setLoadingGet,
    setOrderData,
    setCargoDetails,
    setPartnersForTender,
    partners,
  } = setStateFunctions;

  setLoadingGet(true);

  try {
    const orderPromise = Order.getOrderById(orderId, lang);
    const cargoPromise = orderPromise.then((order) => Order.getCargo(order.data.cargoId));
    
    const promises = [orderPromise, cargoPromise];
    if (partners && partners.length > 0) {
      const tenderPartnersPromise = Order.getTenderPartnersByOrder(orderId).catch(() => ({ data: [] }));
      promises.push(tenderPartnersPromise);
    }
   
    const results = await Promise.all(promises);
    const orderData = results[0];
    const cargoData = results[1];
    const tenderPartnersData = results[2];
    const order = orderData.data;
    setOrderData(order);

    setCargoDetails(cargoData.status === 200 ? cargoData.data : {});
    
    if (tenderPartnersData?.data && tenderPartnersData.data.length > 0 && partners && partners.length > 0) {
      const validTenderPartners = tenderPartnersData.data.filter(tp => tp !== null);
      const tenderPartnerIds = validTenderPartners.map(tp => tp.id);
      const matchedPartners = partners.filter(partner => 
        tenderPartnerIds.includes(partner.expeditorCompanyId)
      );
      setPartnersForTender(matchedPartners);
    }
  } catch (error) {
    console.error(error);
    toast.error("Произошла ошибка, попробуйте позже");
  } finally {
    setLoadingGet(false);
  }
};

export default OrdersParsingData;
